/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceSummary {
    getFixupPrototypeFunction() { return ComplianceSummary.fixupPrototype; }

    static newInstance(model: Partial<ComplianceSummary>): ComplianceSummary {
        let obj = Object.assign(new ComplianceSummary(), model);
        ComplianceSummary.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceSummary>): ComplianceSummary {
        if (!model) return null;
        return ComplianceSummary.newInstance(<ComplianceSummary> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceSummary) {
        if (!obj) return;

        models.ComplianceSummary.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceSummary): boolean {
        Object.setPrototypeOf(obj, ComplianceSummary.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    total_count: string;

    /**
     * page count
     */
    page_count: string;

    /**
     * page
     */
    page: string;

    /**
     * records
     */
    records: any;

}
